.wrapper {
  padding: 1.5rem;
  background-color: var(--bg-color-light);
  border-radius: 5px;
}

.controls {
  display: grid;
  gap: 1rem;
}

@media (min-width: 768px) {
  .controls {
    grid-template-columns: repeat(3, 1fr);
  }
}
